function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { GenUtil } from "imagica-corekit/dist/base/cutil/GenUtil";
import { signal, computed } from "@preact/signals-react";
import { DISPLAY_COUNT } from "../Constant";
import { VBDataNewsVideoList } from "imagica-corekit/dist/base/api/viewBuilderTyped/VBGraphData/VBDataNewsVideoList";
var NewsVideoListState = /*#__PURE__*/function () {
  function NewsVideoListState() {
    _classCallCheck(this, NewsVideoListState);
    _defineProperty(this, "page", 1);
  }
  _createClass(NewsVideoListState, [{
    key: "copyWith",
    value: function copyWith(params) {
      return GenUtil.copyWith(new NewsVideoListState(), this, params);
    }
  }]);
  return NewsVideoListState;
}();
export var NewsVideoListBloc = /*#__PURE__*/function () {
  function NewsVideoListBloc() {
    _classCallCheck(this, NewsVideoListBloc);
    _defineProperty(this, "state", signal(new NewsVideoListState()));
    _defineProperty(this, "props", new VBDataNewsVideoList());
  }
  _createClass(NewsVideoListBloc, [{
    key: "videoList",
    get: function get() {
      var _this = this;
      return computed(function () {
        return _this.props.news_video_collection.slice(0, DISPLAY_COUNT * _this.state.value.page);
      });
    }
  }, {
    key: "showLoadMore",
    get: function get() {
      var _this2 = this;
      return computed(function () {
        return _this2.videoList.value.length + DISPLAY_COUNT <= _this2.props.news_video_collection.length;
      });
    }
  }, {
    key: "setProps",
    value: function setProps(props) {
      this.props = props;
    }
  }, {
    key: "loadMore",
    value: function loadMore() {
      this.state.value = this.state.value.copyWith({
        page: this.state.value.page + 1
      });
    }
  }]);
  return NewsVideoListBloc;
}();